<div class="action" *ngIf="clearButton">
    <ng-content select="fui-clear-button"></ng-content>
</div>
<fui-multiselect-option [field]="field" [key]="key" *ngFor="let option of filteredOptions; let i = index"
                        [option]="option" [attr.id]="'option-' + i"
                        [optionOpenable]="optionOpenable" [attr.option-label]="option[key]"
                        [attr.option-value]="option[field]"
                        [allowLabelMarkup]="allowLabelMarkup"
                        (optionOpened$)="optionOpened$.emit($event)"></fui-multiselect-option>
